import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { withRouter } from "react-router-dom";
import Swal from 'sweetalert2'
import {
  setCartQuantity,
  updateCartItem,
  removeCartItem,
  addCartItem,
  initCart,
} from "../../redux/actions/cart_actions";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const CardCart = ({ ...props }) => {
  const {
    productId,
    productName,
    stock,
    material,
    color,
    image,
    notes,
    price,
    quantity
  } = props.item;

  const renderCardImage = (image) => {
    if (image) {
      return image;
    } else {
      return "";
    }
  };

  //Using useState
  // const [cart, setCart] = useState({
  //   productId: props.item.productId, 
  //   productName: props.item.productName,
  //   stock: props.item.stock,
  //   material: props.item.material,
  //   color: props.item.color,
  //   image: props.item.image,
  //   notes: props.item.notes,
  //   price: props.item.price,
  //   quantity: props.item.quantity
  // })

  useEffect(() => {
    
  }, [quantity]);

  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })
  //Set size Image 
  let widthDetail = 300
  if(props.widthDetail)
    widthDetail = parseInt(props.widthDetail)

  const handleIncreaseQuantity = () => {
    // Check stock product
    if(quantity >= stock)
      return
    //Update state quantity
    let newQuantity = quantity + 1

    let index = props.cart.carts.findIndex((c => c.productId == productId))
    if(index > -1) {
      let newCart = props.cart.carts[index]
      newCart.quantity = newQuantity
      props.dispatch(updateCartItem(newCart, props.cart.carts))
      props.dispatch(setCartQuantity(props.cart.carts))
    }

    // setCart((preState) => ({
    //   ...preState,
    //   quantity: newQuantity
    // }))
  }

  const handleDecreaseQuantity = () => {  
    let newQuantity = quantity - 1

    if(newQuantity > 0) {
      let index = props.cart.carts.findIndex((c => c.productId == productId))
      if(index > -1) {
        let newCart = props.cart.carts[index]
        newCart.quantity = newQuantity
        props.dispatch(updateCartItem(newCart, props.cart.carts))
        props.dispatch(setCartQuantity(props.cart.carts))
        // setCart((preState) => ({
        //   ...preState,
        //   quantity: newQuantity
        // }))
      }    
    }
    else if(newQuantity == 0) {
      return(
        Swal.fire({
          title: 'Xác Nhận',
          text: "Bạn muốn xóa sản phẩm khỏi giỏ hàng?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#000000',
          confirmButtonText: 'Xóa',
          cancelButtonColor: '#999897',
          cancelButtonText: 'Hủy'
        }).then((result) => {
          if (result.value) {   
            let carts = props.cart.carts.filter(c => c.productId != productId)
            props.dispatch(removeCartItem(props.item, props.cart.carts)).then((res) => {
              if(res.payload){
                props.dispatch(setCartQuantity(carts))       
                // window.location.reload(false)
              }              
            })
          }
        })
      )
    }

    // console.log(JSON.parse(localStorage.getItem('sessionProducts')))
  }

  return (
      <>
        <div className="row" style={{ paddingLeft:0, paddingRight:0, marginRight:15, marginLeft:15 }}>
            <div className="col-md-4 col-xs-12 text-center">
              <NavLink to={`/product-detail/${productId}`} style={{color:"black"}}>
                <img src={renderCardImage(image)} className="productImage" style={{ width: widthDetail }} />
                <div className="col">
                  <b>{productName}</b>
                  <br />
                  {notes}
                  <br />
                  Chất liệu: {material}
                  <br />
                  Màu sắc: {color}
                </div>
              </NavLink>
            </div>
            <div className="col-md-8 col-xs-12 text-center" >
              <div className="row" style={{ paddingTop: 50, fontSize:18 }} id="webCartInfo">
                <div className="col-md-4 text-center">{formatter.format(price)}</div>
                <div className="col-md-4 text-center">
                  <a className="decreaseQuantity" onClick={handleDecreaseQuantity}><i className="far fa-minus-square" aria-hidden="true"></i></a> 
                  <b id={`productCartQuantity${productId}`} style={{ padding:10 }}> {quantity} </b>
                  <a className="increaseQuantity" onClick={handleIncreaseQuantity}><i className="far fa-plus-square" aria-hidden="true"></i></a>
                </div>
                <div className="col-md-4 text-center"><b>{formatter.format(quantity*price)}</b></div>              
              </div>
              <div className="row" style={{ paddingTop: 50, fontSize:15 }} id="mobileCartInfo">
                <div className="col-md-4 text-center">Đơn giá: {formatter.format(price)}</div>
                <div className="col-md-4 text-center">Số lượng: 
                  <br />
                  <a className="decreaseQuantity" onClick={handleDecreaseQuantity} style={{ fontSize:20 }}><i className="far fa-minus-square" aria-hidden="true"></i></a> 
                  <b id={`productCartQuantity${props.productId}`} style={{ fontSize:20 }}> {quantity} </b>
                  <a className="increaseQuantity" onClick={handleIncreaseQuantity} style={{ fontSize:20 }}><i className="far fa-plus-square" aria-hidden="true"></i></a>
                </div>
                <div className="col-md-4 text-center">Tổng: <b>{formatter.format(quantity*price)}</b></div>
              </div>
            </div>
        </div>
      <hr className="divider" />
      </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
  };
};

export default connect(mapStateToProps)(CardCart);
